import { Component, EventEmitter, Output } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import {
  IProductOfProvider,
  PRODUCTS_OF_PROVIDER_TTL_ES
} from 'src/app/pages/gestion/products-of-provider/products-of-provider.interface';
import { ProductsOfProviderService } from 'src/app/pages/gestion/products-of-provider/products-of-provider.service';
import { IEventPurchase } from '../purchases.interface';
import { CartPurchaseService } from '../utils-components/cart/cart-purchase.service';
@Component({
  selector: 'pg-purchase-product-to-warehouse-selection',
  templateUrl: './product-to-warehouse-selection.component.html'
})
export class ProductToWarehouseSelectionComponent extends TableActionsTemplate {
  @Output('stepsEmitter') stepsEmitter = new EventEmitter<IEventPurchase>();
  productsSelected: unknown[];

  openSideBar = false;
  constructor(
    private productsOfProviderBase: ProductsOfProviderService,
    private cartPurchaseService: CartPurchaseService
  ) {
    super('', productsOfProviderBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: PRODUCTS_OF_PROVIDER_TTL_ES,
      columns: [
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'description' },
        { header: 'Código de barras', field: 'barCodeProduct' }
      ]
      //
    };
    this.table.actions = [
      {
        name: 'add-product-cart-sale',
        icon: 'pi pi-plus',
        class: 'p-button-rounded p-button-info mr-2',
        pTooltip: 'Agregar Producto'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.productsOfProviderBase
      .getData$()
      .subscribe((data: IProductOfProvider[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  onReciveAction(event): void {
    if (event.action === 'add-product-cart-sale') {
      this.itemSelected.emit(event);
    }
  }

  isCartEmpty() {
    return this.cartPurchaseService.isCartEmpty();
  }

  nextPage() {
    this.stepsEmitter.emit({
      action: 'next',
      data: null
    } as IEventPurchase);
  }

  prevPage() {
    this.stepsEmitter.emit({
      action: 'prev',
      data: null
    } as IEventPurchase);
  }
}
